import React from 'react';
import { PageWithCards } from 'common';
import AddRecipients from './AddRecipients/AddRecipients';
function CheckoutAddRecipients() {
    return (React.createElement(PageWithCards, null,
        React.createElement(AddRecipients, null)));
}
export default CheckoutAddRecipients;
